import { ProStudio } from "@/components/create/ProStudio";
import { ComingSoonHero, QaNotice } from "@/components/create/StudioNotices";
import { WorkflowGallery } from "@/components/create/WorkflowGallery";
import { StudioHeader } from "@/components/create/explore/StudioHeader";
import { hfOpen, useMediaConfig, usePresets } from "@/lib/studio";
import { AD_FLOWS } from "@/lib/workflows";

export default function AdsPage() {
  const config = useMediaConfig().data;
  const covers = (usePresets().data?.items || []).filter((p) => p.category === "Products").map((p) => p.cover_url);
  const open = hfOpen(config);
  return (
    <div className="h-full overflow-y-auto" data-testid="ads-page">
      <StudioHeader title="Ads Studio" back />
      <div className="mx-auto w-full max-w-6xl space-y-8 px-4 pb-20 pt-5 sm:px-6 sm:pt-8">
        {config && !open && <ComingSoonHero covers={covers} testId="ads-coming-soon" title="Ads Studio opens soon" body="Product hero shots, launch posters with clean headlines and product videos from a single photo." />}
        {open && config.higgsfield.access === "qa" && <QaNotice budget={config.image.qa_budget} tools="Ads Studio" />}
        {open && <WorkflowGallery flows={AD_FLOWS} refsFor={() => null} />}
        {open && (
          <section className="space-y-3">
            <h2 className="text-lg font-bold tracking-tight text-white">Ad and marketing models</h2>
            <p className="text-xs text-zinc-500">Ads Studio and Marketing Studio are priced by usage, so they stay visible but can't be launched until a fixed price is approved.</p>
            <ProStudio testId="ads-models" filter={(m) => m.studio === "ads"} />
          </section>
        )}
      </div>
    </div>
  );
}
